import React from 'react';
import PropTypes from 'prop-types';

import {
  AffiliatedRestaurants,
  SafetyMeasures,
  utils,
  VenueImages,
  VenueLocationSummary,
} from '@resy/ui-kitchen';
import VenueShape from '../../../../../../ui-kitchen/src/components/types/venue';

export const formatOriginalImages = (imageObj) => {
  if (!imageObj) return [];
  const imgKeys = Object.keys(imageObj);
  return imgKeys.map((key) => ({
    id: key,
    url: `${imageObj[key]?.url}/1600x1600`,
  }));
};

const VenuePageSidebar = ({
  affiliatedRestaurants,
  ImageServiceConfig,
  isMobile,
  venue,
}) => {
  const renderVenueImages = () => {
    const galleryThumbnailPhotos = utils.getBestVenueImages(venue?.responsiveImages?.urls_by_resolution, true);
    const originalPhotoArray = formatOriginalImages(venue?.responsiveImages?.originals);

    return (
      <VenueImages
        images={venue.images}
        galleryImages={originalPhotoArray}
        galleryThumbnails={galleryThumbnailPhotos}
        venueId={venue.id}
        isMobile={isMobile}
        ImageServiceConfig={ImageServiceConfig}
      />
    );
  };

  return (
    <div className="VenuePageSidebar col-12 col-md-5">
      <div className="offset-md-1 offset-xl-2">
        {!isMobile && renderVenueImages()}

        <SafetyMeasures
          isMobile={isMobile}
          categories={venue.safetyCategories}
          venueName={venue.name}
          venueCity={venue.location.city}
          url={venue.safety_info_url}
        />

        <VenueLocationSummary
          name={venue.name}
          announcement={venue.announcement}
          location={venue.location}
          mapClasses="VenuePage__map"
          menuUrl={venue.contact?.menuUrl}
          social={venue.social}
          url={venue.contact.url}
          pageContext="venue page"
          phone={venue.contact.phone}
          isMobile={isMobile}
          venue={venue}
        />
        {affiliatedRestaurants && (
          <AffiliatedRestaurants
            venueName={venue.name}
            venueCity={venue.location.city}
            venues={affiliatedRestaurants}
          />
        )}
      </div>
    </div>
  );
};

VenuePageSidebar.propTypes = {
  affiliatedRestaurants: PropTypes.arrayOf(VenueShape),
  ImageServiceConfig: PropTypes.shape({
    baseRequestUrl: PropTypes.string,
  }).isRequired,
  isMobile: PropTypes.bool,
  venue: VenueShape.isRequired,
};

VenuePageSidebar.defaultProps = {
  affiliatedRestaurants: [],
  isMobile: false,
};

VenuePageSidebar.displayName = 'VenuePageSidebar';
export default VenuePageSidebar;
